import {RAIL_GROUP_STATUSES} from './trip-change-ticket-component';

const DIRECTIVE_NAME = TripChangeTicketValidator.DIRECTIVE_NAME = 'ktTripChangeTicketValidator';
export default function TripChangeTicketValidator() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, $elem, $attrs, ngModelCtrl) {
            const allowedToBeAmendedStatuses = [
                RAIL_GROUP_STATUSES.OK,
                RAIL_GROUP_STATUSES.ADVANCE_TYPE,
            ];
            function validate(railGroup) {
                const statuses = $scope.$eval($attrs[DIRECTIVE_NAME]);
                const status = !!statuses && statuses[railGroup.Id];
                return status && allowedToBeAmendedStatuses.includes(status);
            }
            ngModelCtrl.$validators[DIRECTIVE_NAME] = validate;
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-change-ticket/trip-change-ticket-validator.js